<template>
  <VRegisterApp name="survey" @mounted="handleMounted" @next="handleNext">
    <!-- <template #header v-if="current">{{ current.Title }}</template> -->
    <el-form ref="formRefs" :model="form" size="large" require-asterisk-position="right" label-width="120px" label-position="top" v-if="pageConfig.questions && pageConfig.questions.length > 0">
      <!--数据处理-->
      <template v-for="(it, idx) in pageConfig.questions" :key="it.id">
        <el-form-item
         v-if="it.id !== '1978418996969472000' || showQuestion5" 
          :prop="it.id"
          :rules="[
            {
              required: it.mandatory || (it.options.length == 1 && it.options[0].text && it.options[0].mandatory),
              validator: (rule, value, callback) => validatorQuestion(it, rule, value, callback),
              trigger: 'blur',
            },
          ]"
          :question-id="it.id"
        >
          <template #label>
            <span>{{ idx + 1 + '、' + it.title }}</span>
            <div @click="handleClear(it.id)" class="clear" v-if="it.clear && form[it.id] && Object.keys(form[it.id]).length > 0">【{{ $t('registration.form.clear') }}】</div>
          </template>
          <VControl v-model="form[it.id]" :data="it" style="width: 100%"   />
        </el-form-item>
      </template>
    </el-form>
  </VRegisterApp>
</template>

<script setup>
  import VRegisterApp from '../app/index.vue'
  import VControl from './control.vue'
  //
  import { onMounted, ref, inject, computed,watch } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import { useRouter } from 'vue-router'
  import { nextTick } from 'process'
  import { ElMessage, ElLoading } from 'element-plus'
  import { survey } from '@/api/registration'
  import { useI18n } from 'vue-i18n'
  const { t, te } = useI18n()
  //

  const router = useRouter()
  const pageConfig = ref({})
  const information = ref({})
  const form = ref({})
  const formRefs = ref(null)

  const $steps = inject('$steps')

    // 控制问题5显示的状态
  const showQuestion5 = ref(false)
// 防抖相关
const watchTimeout = ref(null)
const lastQ4Value = ref(null)

  const current = computed(() => {
    for (var g of $steps.value) {
      if (g.Name == 'survey') {
        return g
      }
    }
    return null
  })

  // 监听form的变化来处理条件显示
  watch(
    () => form.value["1970322450373672960"],
    (newValue, oldValue) => {
      console.log('监听器检测到q4变化:', newValue, '旧值:', oldValue)
    
    // 防抖处理
    if (watchTimeout.value) {
      clearTimeout(watchTimeout.value)
    }
    
    watchTimeout.value = setTimeout(() => {
      // 检查值是否真的变化了
      const newValueStr = JSON.stringify(newValue)
      const oldValueStr = JSON.stringify(oldValue)
      
      if (newValueStr !== oldValueStr) {
        checkQuestion4Answer(newValue)
        lastQ4Value.value = newValueStr
      }
      
      watchTimeout.value = null
    }, 50)
  },
  { deep: true }
)
  // 检查问题4的答案
  const checkQuestion4Answer = (answerData) => {
    console.log('问题4答案数据:', answerData)
    
    if (!answerData) {
      showQuestion5.value = false
      return
    }
    
    let hasYesAnswer = false
    
    // 统一处理各种数据类型
    if (typeof answerData === 'string') {
      hasYesAnswer = answerData === '1970322450373672961'
    } else if (Array.isArray(answerData)) {
      hasYesAnswer = answerData.includes('1970322450373672961')
    } 
    else if (typeof answerData === 'object' && answerData !== null) {
      // 对象类型：检查键或值
      hasYesAnswer = Object.keys(answerData).includes('1970322450373672961') || 
                    Object.values(answerData).some(val => val === '1970322450373672961' || val === true)
    }
    else
       hasYesAnswer = false
    
    console.log('是否包含yes:', hasYesAnswer)
    
  // 只在值真正变化时更新
  if (showQuestion5.value !== hasYesAnswer) {
    showQuestion5.value = hasYesAnswer
  }
    
    if (!showQuestion5.value && form.value["1978418996969472000"]) {
      form.value["1978418996969472000"] = {}
    }
    
    // 重新验证表单
    nextTick(() => {
      formRefs.value?.clearValidate?.()
    })
  }
  //
  const validatorQuestion = (it, rule, value, callback) => {
    console.log('validatorQuestion', form.value, it.id)
    if (it.mandatory) {
      if (!form.value[it.id]) {
        callback(new Error(t(`registration.form.required`, it)))
        return
      }
      if (Object.keys(form.value[it.id]).length === 0) {
        callback(new Error(t(`registration.form.required`, it)))
        return
      }
      //如果当前只有一个值，且为
      if (it.options.length == 1 && it.options[0].text) {
        if (!(form.value[it.id] && form.value[it.id][it.options[0].code])) {
          callback(new Error(t(`registration.form.required`, it)))
          return
        }
      }
    }
    //检查当前选项是否
    for (var g of it.options) {
      if (g.text && g.mandatory && form.value.hasOwnProperty(it.id) && form.value[it.id].hasOwnProperty(g.code) && !form.value[it.id][g.code]) {
        callback(new Error(t(`registration.form.required`, it)))
        return
      }
    }
    callback()
  }
  //
  const handleMounted = (val) => {
    pageConfig.value = val.pageConfig
    information.value = val.information
    //
    pageConfig.value.questions = pageConfig.value.questions.map((data) => {
      var it = { ...data, clear: false }
      let val = data.control
      let max = data.maxNumber || 0
      let hasText = data.options.some((item) => item.text === true)
      if (!((val === 'select' && !hasText) || (data.options.length == 1 && data.options[0].text))) {
        it.clear = true
      }
      return it
    })
    form.value = information.value.questions || {}
    nextTick(() => {
      nextTick(() => {
        formRefs.value.clearValidate()
      })
    })
  }

  const handleNext = () => {
    formRefs.value.validate(async (valid, fields) => {
      console.log('-------------------------------------', valid)
      if (!valid) {
        for (var g in fields) {
          ElMessage({
            message: fields[g][0].message + '',
            type: 'error',
          })
          break
        }
        return
      }
      const loadingInstance = ElLoading.service({ fullscreen: true })
      try {
        const { data } = await survey(form.value)
        router.push({ name: data.to })
      } catch (e) {}
      loadingInstance.close()
    })
  }

  const handleClear = (id) => {
    form.value[id] = {}
  }
</script>

<style lang="scss" scoped>
  .el-form-item {
    :deep() {
      .el-form-item__label {
        color: #363f5e;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .clear {
          color: var(--el-color-primary);
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
</style>
